import React from 'react';
import Services from '../components/sections/Services';

const ServicesPage: React.FC = () => {
  return (
    <div className="services-page">
      <Services />
    </div>
  );
};

export default ServicesPage;
